export default __webpack_public_path__ + "static/media/fr-fr.a2504ba6.svg";